"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var requestAnimationFrame = function requestAnimationFrame(func) {
  window.requestAnimationFrame(func);
};

exports.default = { requestAnimationFrame: requestAnimationFrame };
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-css-collapse/lib/util.js
// module id = 457
// module chunks = 0